
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import PageFooter from '@/components/page-footer.vue';
	import BuyMoreDiscount from './activity-config/buy-more-discount.vue'
	import {
		createActivity,
		updateActivity,
		deleteActivity
	} from '@/api/supplier'
	import Message from '@/components/message.vue';

	@Component({
		name: 'activity-detail',
		components: {
			PageFooter,
			BuyMoreDiscount,
			'slz-message': Message
		}
	})
	export default class ActivityDetail extends Vue {
		private productInfo: any = {
			name: this.$route.query.name,
			id: +this.$route.query.id
		};
		private activityName = '';
		private activityType = 0;
		private activityTypes = [{
			label: '多买优惠',
			value: 0
		}]
		private configData: any = []
		private showMessage = false;
		private showDel = false;
		private isCreate = true
		private activityId = 0

		/**
		 * @func 获取配置数据
		 */
		private getData(obj: any) {
			this.configData = obj.data
			this.isCreate = obj.is_create
			this.activityId = obj.id
		}

		private toBack() {
			this.$router.go(-1)
		}

		private del() {
			if (!this.productInfo.id) {
				this.$message('未配置活动，无法删除！')
				return
			}
			this.showDel = true
		}

		private save() {
			let isEmpty = false
			console.log(this.configData)
			this.configData.map((item: any) => {
				if (!item.quantity) {
					isEmpty = true
					this.$message('请填写起减数量')
				}
			})
			if (isEmpty) return
			this.showMessage = true
		}

		/**
		 * @func 提交信息
		 */
		private handleConfirm() {

			this.doCreate()
		}

		/**
		 * @func 创建操作
		 */
		private async doCreate() {
			try {
				// console.log(this.configData,123)
				await createActivity({
					ProductId: this.productInfo.id,
					ProductBuyMoreDealsList: this.configData.map(item=>{
						return {
							Id: item.Id,
							StartOrDecreaseCount: item.quantity,
							ProductBuyMoreDealsDetailList: item.rule_list.map(obj=>{
								obj.ThirdRolePrice = +obj.ThirdRolePrice;
								return obj
							}),
							SpecBacthGroupPrice:item.SpecBacthGroupPrice,
							SpecBacthRouTuanPrice:item.SpecBacthRouTuanPrice,
							SpecBacthSpreadPrice:item.SpecBacthSpreadPrice,
							SpecBacthThirdRolePrice:item.SpecBacthThirdRolePrice,
							SpecBacthFirstRolePrice:item.SpecBacthFirstRolePrice,
							SpecBacthSecondRolePrice:item.SpecBacthSecondRolePrice,
						}
					})
				})
				this.$message({
					type: 'success',
					message: '创建成功'
				})
				this.toBack()
			} catch (err) {
				console.log(err)
			}
		}

		/**
		 * @func 更新操作
		 */
		private async doUpdate() {
			try {
				await updateActivity({
					plugin: {
						id: this.activityId,
						product_id: this.productInfo.id,
						plugin_type: this.activityType,
						list: this.configData
					}
				})
				this.$message({
					type: 'success',
					message: '创建成功'
				})
				this.toBack()
			} catch (err) {
				console.log(err)
			}
		}

		/**
		 * @func 确认删除
		 */
		private async handleDel() {
			try {
				await deleteActivity({
					ProductId: this.productInfo.id
				})
				this.$message({
					type: 'success',
					message: '删除成功'
				})
				this.toBack()
			} catch (err) {
				console.log(err)
			}
		}
	}
